'use client';

import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

import {
  FlagshipMobileCardLayout,
  FlagshipDesktopCardLayout,
} from './flagship-layouts';

export const FlagshipCardSkeleton = () => {
  const { isMobile } = useResponsive();

  if (isMobile) {
    return (
      <FlagshipMobileCardLayout
        background={<Skeleton className="h-full w-full" />}
        items={null}
        overlay={null}
        price={null}
        quantity={null}
        title={null}
      />
    );
  }

  return (
    <FlagshipDesktopCardLayout
      content={null}
      footer={null}
      items={null}
      overlay={<Skeleton className="absolute inset-0 h-full w-full" />}
    />
  );
};

export const FlagshipMobileCardSkeleton = FlagshipCardSkeleton;
export const FlagshipDesktopSkeleton = FlagshipCardSkeleton;
